var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"box",staticStyle:{"height":"100%"}},[_c('div',{staticStyle:{"height":"100%"},attrs:{"id":"editor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }